import "../../../stylesheets/about-package/about.less";
import "../../../stylesheets/shared-package/shared.less";

import {t} from "@lingui/core/macro";
import {Trans} from "@lingui/react/macro";
import {compose} from "mu-lambda";
import * as React from "react";

import Link from "@khanacademy/wonder-blocks-link";
import {
    enums,
    withConversionContext,
    withMarkConversion,
    type PartialLearningTimeInfo,
    type WithMarkConversionProps,
    type WithoutMarkConversion,
} from "@khan/analytics-learning-time";

import PageRoot from "#app-shell-package/page-root.tsx";

import AboutHeader from "../about-header.tsx";
import AboutNav from "../about-nav.tsx";

import {withStrings} from "./locales/the-team/load-strings.tsx";
import TeamPageBody from "./team-page-body.tsx";

type OwnProps = Empty;
type Props = OwnProps & WithMarkConversionProps;

class TheTeam extends React.Component<Props> {
    componentDidMount() {
        this.props.markConversion({id: "team_page_view"});
    }

    render(): React.ReactNode {
        const footer = (
            <div style={{textAlign: "center"}}>
                <p>
                    <Trans>
                        Khan Academy has also received the time, energy, and
                        expertise of many{" "}
                        <Link href="/about/alumni">past team members</Link>,{" "}
                        <Link href="/contribute/credits">
                            volunteers, and part-time contributors
                        </Link>
                        .
                    </Trans>
                </p>
            </div>
        );

        return (
            <PageRoot settings={{title: t`About the Team`}}>
                <div className="about-page">
                    <AboutHeader
                        pageheadline={t`Meet the Team.`}
                        headercontent={
                            <a href="/careers" className="apply-button">
                                {t`Apply now`}
                            </a>
                        }
                    />
                    <AboutNav aboutSelection="the-team" />
                    <TeamPageBody teamPageName="FULL_TIME" footer={footer} />
                </div>
            </PageRoot>
        );
    }
}

const mapPropsToLearningTime = (): PartialLearningTimeInfo => {
    return {
        activity: enums.Activity.OTHER_ACTIVITY,
        product: enums.Product.OTHER_PRODUCT,
    };
};

type ExportProps = WithoutMarkConversion<
    JSX.LibraryManagedAttributes<
        typeof TheTeam,
        React.ComponentProps<typeof TheTeam>
    >
>;

export default compose(
    withStrings,
    withConversionContext(mapPropsToLearningTime),
    withMarkConversion,
)(TheTeam) as React.ComponentType<ExportProps>;
